import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsDrawerSystemsOptions = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.drawerSystems.options;

export const options = setCalculationModeAdminSettingsDrawerSystemsOptions(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_DRAWER_SYSTEMS_OPTIONS',
  []
);
